import {Modal} from 'components/base-modal/Modal'
import {useDispatch, useSelector} from 'react-redux'
import {AppActions} from 'store/modules/app/actions'

export const ConfirmModal = props => {
  const {
    show,
    title = 'Are you sure?',
    confirmTitle = 'Yes',
    cancelTitle = 'No',
    message
  } = useSelector(state => state.app.confirm)

  const dispatch = useDispatch()

  const confirm = () => {
    dispatch(AppActions.onConfirm())
  }

  const cancel = () => {
    dispatch(AppActions.onCancel())
  }

  return (
    <Modal
      open={show}
      onClose={cancel}
      title={title}
      confirmTitle={confirmTitle}
      onConfirm={confirm}
      confirmButtonProps={{
        className: 'btn btn-danger'
      }}
      cancelTitle={cancelTitle}
      onCancel={cancel}
      footerProps={{
        className: 'modal-footer p-1'
      }}
      center
    >
      {message}
    </Modal>
  )
}
